// extracted by mini-css-extract-plugin
export const artboard = "games-module--artboard--iU6eX";
export const card = "games-module--card--1XgwY";
export const card__side = "games-module--card__side--3iUTN";
export const card__sideFront = "games-module--card__side-front--33oH0";
export const card__sideBack = "games-module--card__side-back--3Zxef";
export const card__theme = "games-module--card__theme--1kRul";
export const card__themeBox = "games-module--card__theme-box--349is";
export const card__subject = "games-module--card__subject--cuESc";
export const card__cover = "games-module--card__cover--3Uk8p";
export const card__heading = "games-module--card__heading--2qF-d";
export const card__headingSpan = "games-module--card__heading-span--3L5oB";
export const card__details = "games-module--card__details--3q-3E";
export const card__title = "games-module--card__title--1Ti-N";